module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0cb6638e17e8c21c8563bc532a010470.png";